<template>
<head>
  <link href="/fontawesome/css/all.css" rel="stylesheet"> <!--load all styles -->
</head>
  <div class="home">
    <h1>Benjamin Mättö</h1>
    <h2>Programmer</h2>
    <ButtonGrid/>
    <div class="links">
      <a href="https://github.com/Risgrynsgrot/" class="fab fa-github fa-lg"></a>
      <a href="https://www.linkedin.com/in/benjamin-mättö" class="fab fa-linkedin fa-lg"></a>
      <a href="mailto:benjaminmatto00@gmail.com" class="fa fa-envelope fa-lg"></a>
     </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ButtonGrid from '@/components/ButtonGrid.vue'

export default {
  name: 'Home',
  components: {
    ButtonGrid
  },
  mounted(){
    document.title = "Benjamin Mättö - Portfolio"
  }
}
</script>

<style scoped>
.home{
  font-size: 140px;
}
h1{
  font-size: 4vw;
  margin-bottom: 0;
}
h2{
  margin-top: 10px;
  margin-bottom: 1%;
  font-size: 1.7vw;
  text-align: center;
}
body{
  width: 100%;
  display: flex;
}

.links{
  text-align: center;
  text-decoration: none;
  color: #eddbb2;
  transition: opacity 0.6s;
  margin-top: 5%;
}
a{
  padding-left: 2%;
  padding-right: 2%;
}
a:link{
  color: #eddbb2;
  text-decoration: none;
}
a:visited{
  color: #eddbb2;
  text-decoration: none;
}
a:hover{
  color: #eddbb2;
  text-decoration: none;
  opacity: 0.5;
  transition: opacity 0.6s;
}

</style>
